import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
import '@polymer/iron-image/iron-image.js';
/**
 * Imagecard element, used for visual information sections like a dashboard tile
 * Normally used to display an image in the top section and wrap a listitem element in the bottom section
 *
 * @prop {String} img - used to define an image to be used as background
 * @prop {String} placeholder - used to define an image to be used as placeholder
 * @prop {String} background - used to set a manual background color
 * @prop {String} background - used to set a manual background color
 * @prop {String} background - used to set a manual background color
 *
 */
let SDBContentCatalogHeaderCard = class SDBContentCatalogHeaderCard extends LitElement {
    constructor() {
        super(...arguments);
        this.img = '';
        this.placeholder = '';
        this.background = '';
        this.overlay = false;
        this.title = '';
        this.description = '';
        this._catalogType = '';
    }
    set type(val) {
        if (!val || val === '')
            return;
        const catalogTypes = ['elearning', 'training', 'video', 'document'];
        if (!catalogTypes.includes(val)) {
            throw new Error(`Possible values for catalogType are ${catalogTypes.join(', ')}`);
        }
        const oldVal = this._catalogType;
        this._catalogType = val;
        this.requestUpdate('catalogType', oldVal);
    }
    get type() {
        return this._catalogType;
    }
    render() {
        return html `
            <section
                id="imageWrapper"
                style="background-color:${this.background}"
            >
                <iron-image
                    class="backgroundImage"
                    sizing="cover"
                    fade
                    preload
                    src="${this.img}"
                    placeholder="${this.placeholder}"
                ></iron-image>
                ${this.overlay
            ? html `<div
                              class="overlay"
                              style="background-color:${this.background}"
                          ></div> `
            : html ``}
            </section>
            <div class="content" name="content">
                <sdb-content-icon id="type" icon=${this._getIconByType()}></sdb-content-icon>
                <div id="favorite">
                    <slot name="favorite"></slot>
                </div>
                <h1 id="contentTitle">${this.title}</h1>
                <span id="contentDescription">${this.description}</span>
                <slot id="contentDetails" name="details"></slot>
            </div>
            </div>
        `;
    }
    _getIconByType() {
        if (this.type === 'elearning') {
            return 'fal fa-graduation-cap';
        }
        else if (this.type === 'training') {
            return 'fal fa-screen-users';
        }
        else if (this.type === 'video') {
            return 'fal fa-video';
        }
        else if (this.type === 'document') {
            return 'fal fa-file-lines';
        }
        else
            return '';
    }
};
SDBContentCatalogHeaderCard.styles = [
    elements,
    css `
            :host {
                cursor: pointer;
                position: relative;
                display: flex;
                height: 250px;
                padding: 15px;
                width: 100%;
                max-width: 250px;
                box-sizing: border-box;
                align-items: flex-end;
                justify-content: center;
                margin: 15px 0;
                transform: rotate(90deg);
            }

            :host,
            .overlay,
            iron-image,
            .content {
                border-radius: 10px;
            }

            section#contentWrapper {
                grid-area: content;
                display: flex;
                flex-flow: column wrap;
                justify-content: stretch;
                align-content: stretch;
                background: white;
                padding: 0;
            }

            .overlay {
                position: absolute;
                z-index: 1;
                width: 100%;
                height: 100%;
                opacity: 0.7;
                top: 0;
                left: 0;
            }

            .content {
                display: grid;
                grid-template-rows: 20px 30px 60px 30px;
                grid-template-columns: 30px 1fr 30px;
                grid-template-areas:
                    'type . favorite'
                    'title title title'
                    'description description description'
                    'details details details';
                z-index: 2;
                padding: 15px;
                height: 65%;
                width: 100%;
                align-items: center;
                justify-items: center;
                background-color: rgba(255, 255, 255, 0.7);
                backdrop-filter: blur(7.5px);
            }

            #type {
                grid-area: type;
                color: var(--text-primary);
            }

            #favorite {
                grid-area: favorite;
                z-index: 3;
            }

            #contentTitle {
                grid-area: title;
                width: 100%;
                height: 30px;
                line-height: 30px;
                margin: 0;
                color: var(--text-primary);
                font-size: 1.1em;
                font-weight: 400;
            }

            #contentDescription {
                grid-area: description;
                color: var(--text-primary);
                font-weight: 300;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
            }

            #contentDetails {
                grid-area: details;
            }

            .backgroundImage {
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
                display: block;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentCatalogHeaderCard.prototype, "img", void 0);
__decorate([
    property({ type: String })
], SDBContentCatalogHeaderCard.prototype, "placeholder", void 0);
__decorate([
    property({ type: String })
], SDBContentCatalogHeaderCard.prototype, "background", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentCatalogHeaderCard.prototype, "overlay", void 0);
__decorate([
    property({ type: String })
], SDBContentCatalogHeaderCard.prototype, "title", void 0);
__decorate([
    property({ type: String })
], SDBContentCatalogHeaderCard.prototype, "description", void 0);
__decorate([
    property({ type: String, reflect: true })
], SDBContentCatalogHeaderCard.prototype, "type", null);
SDBContentCatalogHeaderCard = __decorate([
    customElement('sdb-content-catalogheadercard')
], SDBContentCatalogHeaderCard);
export { SDBContentCatalogHeaderCard };
//# sourceMappingURL=sdb-content-catalogheadercard.js.map